<template lang="pug">
.wrap
  section
    .tab-wrap
      .tab-item(v-for="(day, index) in days", @click="nowTab = index", :class="{actived: nowTab === index}") {{ day }}
    .mb-3
    div(style="text-align: center; padding: 6px; color: #868686") *以現場活動執行時間為主
  .mb-4
  //- section(v-if="nowTab === -1")
    .section-title 敬請期待
  section(v-if="nowTab === 0")
    .section-title {{days[0]}} 節目表
    .mb-4
    .program-list
      .list.col-sm-4.col-md-3.col-md-offset-1
        .list-head 主舞台
        .list-content
          ul
            li
              .time 10:30-11:30
              .title WirForce 2017 記者會
            li
              .time 12:00-20:00
              .title
                | 台北盃電競大賽
                br
                | 個人項目 16 強總決賽 -《快打旋風V》
      .list.col-sm-4.col-md-3
        .list-head BYOC舞台
        .list-content
          ul
            //- li(v-for="show in 4")
              .time 16:00
              .title 爐石四強
      .list.col-sm-4.col-md-3
        .list-head 野台
        .list-content
          ul
            //- li(v-for="show in 6")
              .time 16:00
              .title 爐石四強
      //- .list.col-sm-4.col-md-3
        .list-head 八角擂台
        .list-content
          ul
            //- li(v-for="show in 5")
              .time 16:00
              .title 爐石四強
  section(v-if="nowTab === 1")
    .section-title {{days[1]}} 節目表
    .mb-4
    .program-list
      .list.col-sm-4.col-md-3.col-md-offset-1
        .list-head 主舞台
        .list-content
          ul
            li
              .time 11:30-14:30
              .title
                | 《部落衝突:皇室戰爭》
                br
                | 2017皇冠錦標賽東南亞賽區外卡賽
            li
              .time 14:30-17:00
              .title
                | BYOC Fight
                br
                | PC《絕對武力：1.6》總決賽
            li
              .time 17:00-20:00
              .title
                | NVIDIA X 天命 2
                br
                | 三人成軍，奪回家園！
            li
              .time 22:00-23:30
              .title WirForce 2017 開幕演出
      .list.col-sm-4.col-md-3
        .list-head BYOC舞台
        .list-content
          ul
            li
              .time 18:00-19:00
              .title
                | Twitch 神秘活動
            li
              .time 19:00-21:00
              .title
                | ROG X WirForce
                br
                | 第一神拳
            li
              .time 24:00-01:00
              .title WirForce 大胃王 III
            li
              .time 01:00-02:00
              .title 鮮乳坊 X WirForce 擠牛奶
      .list.col-sm-4.col-md-3
        .list-head 野台
        .list-content
          ul
            li
              .time 16:30 - 17:30
              .title ahq 誓師大會
            li
              .time 18:00 - 19:00
              .title 双響泡熱血運動會
            li
              .time 19:00 - 20:00
              .title
                | 6tan x 惡王：
                br
                | 職業摔角 x Gamer訪談
      //- .list.col-sm-4.col-md-3
        .list-head 八角擂台
        .list-content
          ul
            li(v-for="show in 3")
              .time 16:00
              .title 爐石四強
  section(v-if="nowTab === 2")
    .section-title {{days[2]}} 節目表
    .mb-4
    .program-list
      .list.col-sm-4.col-md-3.col-md-offset-1
        .list-head 主舞台
        .list-content
          ul
            li
              .time 11:00-14:00
              .title
                | 中華電信 BYOC Fight
                br
                | 《英雄聯盟》總決賽
            li
              .time 14:00-17:00
              .title
                | Shadowverse
                br
                | 台日韓邀請賽
            li
              .time 17:30-20:00
              .title
                | AORUS BYOC Fight
                br
                | 《絕地求生》總決賽
            li
              .time 22:00-24:00
              .title
                | WirForce 2017
                br
                | DJ / 音樂會
      .list.col-sm-4.col-md-3
        .list-head BYOC舞台
        .list-content
          ul
            li
              .time 13:30-14:30
              .title
                | Gigabyte 工商時間
                br
                | (AORUS彩盒疊疊樂)
            li
              .time 15:00-16:00
              .title
                | GeForce X 誰是槍王
            li
              .time 16:00-18:00
              .title
                | GeForce X WirForce
                br
                | 肥宅運動大會
            li
              .time 19:00-21:00
              .title
                | 中華電信 X WirForce
                br
                | 知識王 II
            li
              .time 23:30-00:30
              .title
                | WirForce Just Dance
                br
                | 熱舞大賽 IV
      .list.col-sm-4.col-md-3
        .list-head 野台
        .list-content
          ul
            li
              .time 12:00-12:30
              .title
                | MSI x 閃電狼粉絲見面會
            li
              .time 13:00-13:30
              .title
                | AGON電競顯示器
                br
                | 視感對決
            li
              .time 14:00-14:30
              .title
                | 璐加雪糖
            li
              .time 14:30-20:00
              .title
                | 熱舞大賽 IV
                br
                | 《 Just Dance 舞力全開2018 》
      //- .list.col-sm-4.col-md-3
        .list-head 八角擂台
        .list-content
          ul
            li(v-for="show in 2")
              .time 16:00
              .title 爐石四強
  section(v-if="nowTab === 3")
    .section-title {{days[3]}} 節目表
    .mb-4
    .program-list
      .list.col-sm-4.col-md-3.col-md-offset-1
        .list-head 主舞台
        .list-content
          ul
            li
              .time 11:00-13:30
              .title
                | 台北盃電競大賽
                br
                | 團體項目總決賽 -《傳說對決》
            li
              .time 13:30-16:00
              .title
                | 台北盃電競大賽
                br
                | 個人項目 總決賽 -《快打旋風 V》
            li
              .time 16:30-17:00
              .title
                | WirForce 2017
                br
                | 成就獎項頒發
            li
              .time 17:00-17:30
              .title 閉幕
      .list.col-sm-4.col-md-3
        .list-head BYOC舞台
        .list-content
          ul
            li(v-for="show in 1")
              .time 14:30-16:00
              .title
                | WirForce
                br
                | 收垃圾清場大作戰
      .list.col-sm-4.col-md-3
        .list-head 野台
        .list-content
          ul
            li
              .time 12:00-15:30
              .title
                | WirForce 次元的聲音
                br
                |欣家
                br
                |Kameko | 龜子
                br
                |LOAM
                br
                |赤咲
                br
                |DJ Sean Wang
      //- .list.col-sm-4.col-md-3
        .list-head 八角擂台
        .list-content
          ul
            li(v-for="show in 4")
              .time 16:00
              .title 爐石四強
</template>

<script>
import { mapGetters } from 'vuex'
// import _ from 'lodash'

export default {
  name: 'programList',
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
    })
  },
  // props: {
  //   fullScreenCount: {
  //     type: Object
  //   },
  //   isMobile: {
  //     type: Boolean
  //   },
  //   mobileMenuSwitch: {
  //     type: [Boolean, Function]
  //   },
  //   isPortrait: {
  //     type: Boolean
  //   }
  // },
  data () {
    return {
      nowTab: 0,
      days: ['11/23 (四)', '11/24 (五)', '11/25 (六)', '11/26 (日)']
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
  },
  mounted () {
    // Place images after loaded
    this.$Lazyload.$on('loaded', () => {
      console.log('Loaded')
    })
  },
  watch: {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/components'
@import '~stylesheets/mixin'
</style>



// WEBPACK FOOTER //
// programList.vue?083c2e57